import { Set } from 'immutable';

import { GetState, ReduxAction, ThunkDispatchType } from 'app/redux/types';

import { StakeType } from 'app/lib/staking/constants';

import { AccountType, AmountInputModifier } from '../constants';
import { selectCurrentStakeType } from '../selectors/stakeTypes';
import { parseAmount } from './parsing';

// ---

type Payload = {
  value: string;
  numeric: number;
  account: AccountType;
  modifier: AmountInputModifier | null;
  stakeType: Set<StakeType>;
};

export type ChangeStakeTypeAction<T extends string> = ReduxAction<T, Payload>;
export type ChangeStakeTypeAmountFactory<T extends string> = (
  dispatch: ThunkDispatchType<ChangeStakeTypeAction<T>>,
  getState: GetState,
) => void;

export function createChangeStakeTypeAmountFactory<T extends string>(type: T) {
  return (
    value: string,
    account: AccountType,
    modifier: AmountInputModifier | null = null,
  ): ChangeStakeTypeAmountFactory<T> => {
    return (dispatch, getState) => {
      const state = getState();

      const stakeType = selectCurrentStakeType(state);

      const payload: Payload = {
        value,
        numeric: parseAmount(value),
        account,
        modifier,
        stakeType,
      };

      dispatch({ type, payload });
    };
  };
}
